import type { TimerConfig } from '$store/loaders/timers.tsx'
import type { Product } from 'apps/commerce/types.ts'

export interface UseTimersProps {
    timers?: TimerConfig[]
    product: Product
}

export function useTimers({ timers = [], product }: UseTimersProps) {
    const { additionalProperty = [], inProductGroupWithID = 0 } = product

    const filteredTimers = timers.filter(({ matchers = [] }) => {
        return matchers.some(({ matcherType, id }) => {
            if (matcherType === 'product') {
                return id === inProductGroupWithID
            }

            return additionalProperty.some(({ name, propertyID }) => {
                return name === matcherType && propertyID === String(id)
            })
        })
    })

    return { filteredTimers }
}
